import styled from 'styled-components';

export const PostBlankWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
`;
